import { t } from '@/utils/i18n'

const span = (plainText) => {
  const result =
    plainText?.replace(/{{mention:(.*?)}}/gi, (match) => {
      const options = JSON.parse(JSON.parse([...match.matchAll(/{{mention:(.*?)}}/gi)][0][1]))

      const fullName = options?.fullName || t('not-available')
      const isAnonymous = options?.isAnonymous === true || options?.isAnonymous === 'true'
      const toModerator = options?.toModerator === true || options?.toModerator === 'true'
      const userId = options?.userId
      const prospectId = options?.prospectId
      const anonymousId = options?.anonymousId || ''

      const text =
        isAnonymous && !userId && !prospectId
          ? toModerator
            ? '@Moderator'
            : `@Member${anonymousId || ''}`
          : `@${fullName}`

      return `<span class="mention"${options?.mentionId ? ` mention-id="${options?.mentionId}"` : ''}${
        options?.isReply !== undefined ? ` is-reply="${options?.isReply}"` : ''
      }${options?.isAnonymous !== undefined ? ` is-anonymous="${options?.isAnonymous}"` : ''}${
        options?.toModerator !== undefined ? ` to-moderator="${options?.toModerator}"` : ''
      }${options?.anonymousId ? ` anonymous-id="${options?.anonymousId}"` : ''}>${text}</span>`
    }) || ''
  return result
}

const tiptap = (plainText) => {
  const result =
    plainText?.replace(/{{mention:(.*?)}}/gi, (match) => {
      const options = JSON.parse(JSON.parse([...match.matchAll(/{{mention:(.*?)}}/gi)][0][1]))

      const fullName = options?.fullName || t('not-available')
      const isAnonymous = options?.isAnonymous === true || options?.isAnonymous === 'true'
      const toModerator = options?.toModerator === true || options?.toModerator === 'true'
      const userId = options?.userId
      const prospectId = options?.prospectId
      const anonymousId = options?.anonymousId || ''

      const text =
        isAnonymous && !userId && !prospectId
          ? toModerator
            ? '@Moderator'
            : `@Member${anonymousId || ''}`
          : `@${fullName}`

      return `<span class="mention"${options?.prospectId ? ` prospect-id="${options?.prospectId}"` : ''}${
        options?.userId ? ` user-id="${options?.userId}"` : ''
      }${options?.fullName ? ` full-name="${options?.fullName}"` : ''}${
        options?.mentionId ? ` mention-id="${options?.mentionId}"` : ''
      }${options?.isReply !== undefined ? ` is-reply="${options?.isReply}"` : ''}${
        options?.isAnonymous !== undefined ? ` is-anonymous="${options?.isAnonymous}"` : ''
      }${options?.toModerator !== undefined ? ` to-moderator="${options?.toModerator}"` : ''}${
        options?.anonymousId ? ` anonymous-id="${options?.anonymousId}"` : ''
      }>${text}</span>`
    }) || ''
  return result
}

export default { tiptap, span }
